import type { MutableRefObject } from 'react';
import FieldRenderer from './FieldRenderer';
import { FormRendererProvider } from './FormRendererContext';
import type { FieldSchema } from './types';
import type { Map as LeafletMap } from 'leaflet';

interface FormRendererProps {
  fields: FieldSchema[];
  mapRef: MutableRefObject<LeafletMap | null>;
  isLoadingSensorData: boolean;
}

const FormRenderer = ({ fields, mapRef, isLoadingSensorData }: FormRendererProps) => (
  <FormRendererProvider value={{ mapRef, isLoadingSensorData }}>
    {fields?.map((field) => <FieldRenderer key={field.name || field.label} field={field} />)}
  </FormRendererProvider>
);

export default FormRenderer;
